export type GetAllSSResponse = {
  data: BasicSS[];
  meta: SismetroMeta;
};
export type GetPatrimonioResponse = {
  id: number;
  name: string;
};
export type SismetroMeta = {
  current_page: number;
  items_per_page: number;
  total_items: number;
  total_pages: number;
  hasNext: boolean;
};
export type BasicSS = {
  dataAbertura: string;
  descricaoSs: string;
  idSs: string;
  localizacao: string;
  solicitante: string;
  status: string;
  tipoSs: string;
};

export type SismetroDetails = {
  idSS: number;
  tipoSS: string | null;
  categoria: string | null;
  abertoPor: string | null;
  dataAbertura: Date | null;
  dataEncerramento: Date | null;
  solicitante: string | null;
  tipoTec: string | null;
  tag: string | null;
  descricaoSs: string | null;
  gravidade: number | null;
  urgencia: number | null;
  tendencia: number | null;
  gut: number | null;
  historicoEvolucao: {
    id: number | null;
    idEvolucao: number | null;
    evolucao: string | null;
    dataHoraInicio: string | null;
    dataHoraFim: string | null;
  }[];

  horasLancamentos: {
    tecnico: {
      id: number | null;
      nome: string | null;
      funcionario: {
        id: number;
        nome: string | null;
        idErp: string | null;
        idCracha: unknown | null;
        centroCusto: unknown | null;
        custo: unknown | null;
        cargaHoraria: unknown | null;
        status: string | null;
      };
    };
    lancamentos: {
      inicio: string | null;
      fim: string | null;
      tipo: string | null;
      status: string | null;
      centroCusto: unknown | null;
      filial: unknown | null;
    }[];

    paradas: {
      inicio: string | null;
      fim: string | null;
      tipo: string | null;
      status: string | null;
      centroCusto: unknown | null;
      filial: unknown | null;
    }[];
  }[];
  horasTrabalhadas: string | null;
  horasParadas: string | null;
  localizacao: string | null;
};

export enum SismetroListType {
  Open = 1,
  Closed = 2,
  All = 3,
}

export type ServiceRequest = {
  ug: string;
  area: string;
  descricao: string;
  solutions: string;
  alarmRoute?: string;
};

export enum UrgenciaType {
  PodeEperar = 1,
  PoucoUrgente,
  OMaisRapido,
  Urgente,
  NecessitaAcaoImediata,
}

export enum TendenciaType {
  NaoIraPiorar = 1,
  IraPiorarLongoPrazo,
  IraPiorarMedioPrazo,
  IraPiorarPoucoTempo,
  IraPiorarRapidamente,
}

export enum GravidadeType {
  SemGravidade = 1,
  PoucoGrave,
  Grave,
  MuitoGrave,
  ExtremamenteGrave,
}
